import "./InitialContactInJapanese.module.css";
import LegalHero from "./sections/LegalHero";
import Intake from "./sections/Intake";
import Contact from "./sections/Contact";
import Professionalnetwork from "./sections/Professionalnetwork";
import Footer from "@/reusable_sections/Footer";
import PracticeAreasList from "./sections/PracticeAreasList";
import ConsultationProcess from "./sections/ConsultationProcess";
import Legal from "./sections/Legal";
export default function InitialContactInJapanesePage() {
  return <div>
      <div id="about" className="scroll-mt-24">
        <LegalHero />
      </div>

      <div id="services" className="scroll-mt-24">
        <PracticeAreasList />
      </div>

      <div id="process" className="scroll-mt-24">
        <ConsultationProcess />
      </div>

      <div id="philosophy" className="scroll-mt-24">
        <Professionalnetwork />
      </div>

      <div id="legal" className="scroll-mt-24">
        <Legal />
      </div>

      <div id="intake" className="scroll-mt-24">
        <Intake />
      </div>

      <div id="contact" className="scroll-mt-24">
        <Contact />
      </div>

      <Footer />
    </div>;
}